import React from "react";
import Tab from "@material-ui/core/Tab";
import { withStyles } from "@material-ui/styles";

import colors from "../../assets/style/colors";
import images from "../../assets/img/images";

const styles = {
  root: {
    textTransform: "initial",
    fontSize: "1em",
    fontWeight: "400",
    color: colors.black54,
    marginRight: "20px",
    minWidth: "100px",
    opacity: "1.0",
  },
  selected: {
    color: colors.black87,
    fontWeight: "500",
    borderBottom: "2px solid " + colors.primary,
  },
  wrapper: {
    display: "flex",
    flexDirection: "row",
  },
};

const CustomTab = (props) => {
  let newProps = { ...props };
  delete newProps.overridenIcon;
  delete newProps.label;
  delete newProps.rootClass;
  let overriden = props.overridenIcon || false;

  return (
    <Tab
      classes={{
        root: props.rootClass || props.classes.root,
        selected: props.selectedClass || props.classes.selected,
        wrapper: props.classes.wrapper,
      }}
      icon={props.icon}
      label={
        overriden ? (
          <OverridenTab label={props.label} selected={props.selected} />
        ) : (
          props.label
        )
      }
      disableRipple={true}
      style={{
        height: props.height || "50px",
        padding: 0,
        minHeight: props.height || "initial",
      }}
      {...newProps}
    />
  );
};

const OverridenTab = (props) => {
  return (
    <span style={{ display: "flex" }}>
      <span>{props.label}</span>
      <img
        src={
          props.selected ? images.overrideIconBlack : images.overrideIconGrey
        }
        alt="override_icon"
        style={{ marginLeft: "8px" }}
      />
    </span>
  );
};

export default withStyles(styles)(CustomTab);
